<template>
  <div>
    <imgHeader imgUrl="/img/7社会责任-banner.jpg" />
    <div class="w">
      <h3 class="title" style="text-align:center;">{{ $t('responsibility.title') }}</h3>
      <div class="line line1"></div>
      <div class="details">
        <div>{{ desc1 }}</div>
        <div>{{ desc2 }}</div>
        <div>{{ desc3 }}</div>
        <div>{{ desc4 }}</div>
        <div>{{ desc5 }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { t } from '@/VueI18n'

export default {
  name: 'Responsibility',
  data() {
    return {
      desc1: t('responsibility.desc1'),
      desc2: t('responsibility.desc2'),
      desc3: t('responsibility.desc3'),
      desc4: t('responsibility.desc4'),
      desc5: t('responsibility.desc5'),
    }
  },
  watch: {
    '$i18n.locale'() {
      this.updateText()
    }
  },
  mounted() {
    this.updateText()
  },
  methods: {
    updateText() {
      this.desc1 = t('responsibility.desc1')
      this.desc2 = t('responsibility.desc2')
      this.desc3 = t('responsibility.desc3')
      this.desc4 = t('responsibility.desc4')
      this.desc5 = t('responsibility.desc5')
    }
  },
}
</script>

<style lang="scss" scoped>
.details {
  margin-top: 64px;
  margin-bottom: 90px;
  div {
    margin-bottom: 36px;
    font-size: 18px;
    color: #333;
    text-align: center;
  }
}
</style>